import { combineReducers } from 'redux';
import { modelReducer, formReducer } from 'react-redux-form';
import { stepsReducer } from './steps';
import options from './options';
import focus from './focus';
import standBy from './standBy';
import sign from './sign';
import modalCancel from './modalCancel';
import map from './map';
import preLoader from './preLoader';
import initialStep from './initialStep';
import session from './session';
import identify from './identify';
import video from './video';
import documentation from './documentation';
import promotionalCode from './promotionalCode';
import error from './error/error';
import header from './header';
import jointHoldersStatus from './jointHoldersStatus';
import cardImages from './cardImages';
import products from './products';
import gdprConsents from 'gdpr-consents/reducers/gdprConsents';
import wealthProduct from './wealthProduct';
import iban from 'ok-iban/dist/reducers/iban';
import cms from './cms';
import scorings from './scorings';
import raCheckStatus from './RACheckStatus';
import raSuitabilityTest from './RASuitabilityTest';
import { RASuitabilityTestWizardReducer } from './RASuitabilityTestWizard';
import raManagementPlan from './RAManagementPlan';
import raPortfolioDistribution from './RAPortfolioDistribution';
import raTimeHorizonCheck from './RATimeHorizonCheck';
import raExpectedProfitability from './RAExpectedProfitability';
import raCustomPlanByObjective from './RACustomPlanByObjective';
import raHireManagementPlan from './RAHireManagementPlan';
import raSetGoal from './RASetGoal';
import raSimulation from './RASimulation';
import hireCardImageSelector from './hireCardImageSelector';
import { loginRobo } from './loginRobo';
import globalErrorModal from './globalErrorModal';
import hireSolidarityCard from './hireSolidarityCard';
import translations from './translations';
import alreadyClientData from './validationAlreadyClient';
import featureFlagging from './featureFlagging';
import videoAvailability from './videoAvailability';
import polling from './polling';

export const reducers = {
    alreadyClientData,
    cardImages,
    cms,
    contactOfficerForm: formReducer('contactOfficerForm'),
    documentation,
    error,
    extraData: modelReducer('extraData'),
    featureFlagging,
    focus,
    form: formReducer,
    gdprConsents,
    header,
    hireCardImageSelector,
    hireSolidarityCard,
    iban,
    identify,
    initialStep,
    jointHoldersStatus,
    loginRobo,
    map,
    modalCancel,
    options,
    polling,
    preLoader,
    products,
    promotionalCode,
    raCheckStatus,
    raCustomPlanByObjective,
    raExpectedProfitability,
    raHireManagementPlan,
    raManagementPlan,
    raPortfolioDistribution,
    raSetGoal,
    raSimulation,
    raSuitabilityTest,
    raSuitabilityTestWizard: RASuitabilityTestWizardReducer,
    raTimeHorizonCheck,
    scorings,
    session,
    sign,
    standBy,
    steps: stepsReducer,
    translations,
    globalErrorModal,
    userProfile: modelReducer('userProfile', {}),
    userProfileForm: formReducer('userProfile', {}),
    video,
    videoAvailability,
    wealthProduct,
};

export const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
    const shouldResetStore = action.type === 'RESET_STORE';

    return appReducer(shouldResetStore ? undefined : state, action);
};
export default rootReducer;
